export default "__VITE_ASSET__DnNgI50j__"